import React from 'react'
import useGeoentityListItem from './useGeoentityListItem'
import { getColorFromOpeningStatus } from '../../store/geoentity/geoentity.helpers'
import SVGIcon from '../svg/SVGIcon'
import s from './GeoentityListItem.less'
import cultery from '../genericComponents/assets/cultery.svg'
import Reviews from './Reviews'
import GeoentityOpeningMessage from './GeoentityOpeningMessage'
import CornerShops from './CornerShops'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'
import GoToGeoentityButton from './GoToGeoentityButton'
import { ReservationButton } from './ReservationButton'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'

const getCookingType = (prestations = '') => /Types de cuisine : ([^,]+)/.exec(prestations)?.[1]

const GeoentityGenericListItemDetails = ({ poi, noExternalButtons }) => {
  const { additionalInfo = {}, cornerShops, openingStatus, reviews } = poi
  const { teasing, secondTeasing, prestations } = additionalInfo
  const { reservationUrl, clickTagPropsForRedirection } = useGeoentityListItem(poi)
  const cookingType = getCookingType(prestations)

  const { message: openingMessage, status } = openingStatus ?? {}
  const openingMessageColor = getColorFromOpeningStatus(status)

  return (
    <>
      {cookingType && (
        <div className={s.cookingType}>
          <SVGIcon url={cultery} />
          <div className={s.text}>{cookingType}</div>
        </div>
      )}
      <div className={s.text}>
        <Reviews reviews={reviews} />
      </div>
      {teasing && <div className={s.text} dangerouslySetInnerHTML={{ __html: teasing }} />}
      {secondTeasing && <div className={s.text} dangerouslySetInnerHTML={{ __html: secondTeasing }} />}
      <GeoentityOpeningMessage openingMessage={openingMessage} openingMessageColor={openingMessageColor} />
      <CornerShops cornerShops={cornerShops} />
      <div className={s.button}>
        <GoToGeoentityButton poi={poi} tagInfo={{ [CLICKED_BUTTON]: "Plus d'infos" }}>
          <RectangleActionButton
            label="Plus d'infos"
            color={COLOR_GREY_EMPTY}
            className={noExternalButtons ? s.fakeButtonLandingPage : s.buttonMoreInfo}
            size={SIZE_MEDIUM}
          />
        </GoToGeoentityButton>
        {!noExternalButtons && reservationUrl && (
          <ReservationButton
            reservationUrl={reservationUrl}
            clickTagPropsForRedirection={clickTagPropsForRedirection}
          />
        )}
      </div>
    </>
  )
}

export default GeoentityGenericListItemDetails
